export const jobCategoryUris: Record<string, string> = {
  'Developer + Engineer': 'dev-engineering',
  'Data + Analytics': 'data-analytics',
  'Design + UX': 'design-ux',
  'HR + Recruiting': 'hr',
  'Project Mgmt': 'project-management',
};
